import React, { useState, useRef, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text, CircularProgress,
    InputGroup, InputRightElement, Icon, IconButton,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, ModalFooter, Textarea
} from '@chakra-ui/react';
import { MdSave } from 'react-icons/md';
import { Form, Field } from 'react-final-form';

function AddEditMedicineImportExportModal({ 
    company_id, medicineImportExportDetail, actionStatus, initialRef, isOpen, onClose, 
    medicine_id, isImport, apiCreateNewMedicineImportExport, apiUpdateAMedicineImportExport,
}) {
    const [ cookies ] = useCookies(["loginCookie"]);
    const [ isProcessing, setIsProcessing ] = useState(false);

    useEffect(() => {
        if(!actionStatus) {
            setIsProcessing(false);
        }
    }, [actionStatus]);

    const validate = (values) => {
        const errors = {};

        if(!values.vendor) {
            errors.vendor = "Required";
        }
        if(!values.quantity) {
            errors.quantity = "Required";
        }

        return errors;
    }

    const onSubmit = async(values) => {
        setIsProcessing(true);
        if(medicineImportExportDetail && medicineImportExportDetail.id) {
            apiUpdateAMedicineImportExport({ 
                id: medicineImportExportDetail.id, 
                payload: {
                    ...values,
                    user_id: cookies?.loginCookie?.data?.id,  
                }
            });
        } else {
            apiCreateNewMedicineImportExport({ 
                ...values,
                medicine_id,
                isImport,
                user_id: cookies?.loginCookie?.data?.id, 
            });
        }

        onClose();
    }

    return (
        <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} size="xl">
            <ModalOverlay />
            <Form
                onSubmit={onSubmit}
                initialValues={{
                    company_id,
                    ...medicineImportExportDetail
                }}
                validate={validate}
                render={({ handleSubmit, form, submitting, pristine, valid, values }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <ModalContent>
                                <ModalHeader>
                                    { 
                                        medicineImportExportDetail && medicineImportExportDetail.id ? 
                                            (isImport ? "NHẬP - CẬP NHẬT" : "XUẤT - CẬP NHẬT") : 
                                            (isImport ? "NHẬP - TẠO MỚI" : "XUẤT - TẠO MỚI")
                                    }
                                </ModalHeader>
                                <ModalCloseButton />

                                <ModalBody pb={6}>
                                    <Flex flexDirection="column" mx={2} my={2} justify="space-between" gap={2}>
                                            <Field name="vendor">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel fontWeight="700">{ isImport ? "Nhà cung cấp" : "Đơn vị/Người được xuất" }:</FormLabel>
                                                        <Input {...input} type='text' placeholder=''/>
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="quantity">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel fontWeight="700">Số lượng:</FormLabel>
                                                        <Input {...input} type='number' placeholder=''/>
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="price">
                                                {({ input, meta }) => (
                                                    <FormControl>
                                                        <FormLabel fontWeight="700">{ isImport ? "Giá mua" : "Giá bán" }:</FormLabel>
                                                        <Input {...input} type='number' placeholder=''/>
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="issued_by">
                                                {({ input, meta }) => (
                                                    <FormControl>
                                                        <FormLabel fontWeight="700">Người { isImport ? "nhập": "xuất" }:</FormLabel>
                                                        <Input {...input} type='text' placeholder=''/>
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="description">
                                                {({ input, meta }) => (
                                                    <FormControl>
                                                        <FormLabel fontWeight="700">Ghi chú:</FormLabel>
                                                        <Textarea {...input} placeholder='' rows={4}/>
                                                    </FormControl>
                                                )}
                                            </Field>
                                    </Flex>
                                </ModalBody>

                                <ModalFooter>
                                    <Button colorScheme='blue' mr={3} type='submit' isDisabled={!valid | pristine}
                                        isLoading={isProcessing}
                                        loadingText="Đang lưu"
                                    >
                                        <Icon boxSize={6} as={MdSave} marginRight="8px"/> 
                                        <Text fontSize="14px">Lưu</Text>
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </form>
                    )
                }}
            />
        </Modal>
    )
}

export default AddEditMedicineImportExportModal;